import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_4 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_5 = { class: "text-sm text-gray-900 truncate" }
const _hoisted_6 = { class: "text-sm text-gray-900 truncate" }
const _hoisted_7 = { class: "text-sm text-gray-900 truncate" }

import { computed, onMounted, ref } from 'vue'

import { onOffBadge, workflowActionsLabel, workflowTriggerLabel } from '@/helpers/automationLists'
import api from '@/store/api'
import { mapRelationships, mapTypeIncludingInactive } from '@/store/mappers'
import NewAutomationButton from '@/view/automations/NewAutomationButton.vue'

const pageSize = 10

export default {
  __name: 'WorkflowList',
  setup(__props) {

const loading = ref(true)
const page = ref(0)

const columns = [
  { width: 'minmax(200px, 2fr)' },
  { width: 'minmax(140px, 1fr)' },
  { width: 'minmax(220px, 2fr)' },
  { width: '120px' },
  { width: '100px' }
]

const workflows = computed(() => mapTypeIncludingInactive('workflow').sort((a, b) => b.id - a.id))
const pageRows = computed(() => workflows.value.slice(page.value * pageSize, (page.value + 1) * pageSize))

const triggerLabel = workflow => {
  const trigger = mapRelationships(workflow.relationships?.workflow_triggers?.data || [])[0]
  return workflowTriggerLabel(trigger?.attributes?.type)
}

const actionsLabel = workflow =>
  workflowActionsLabel(mapRelationships(workflow.relationships?.workflow_actions?.data || []))

const statusBadge = workflow => onOffBadge(workflow.attributes.is_active !== false, 'Active', 'Inactive')

const createdAt = timestamp =>
  new Intl.DateTimeFormat([], { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(timestamp))

onMounted(() => {
  api.call('GET', 'workflows?included=workflow_triggers,workflow_actions').finally(() => {
    loading.value = false
  })
})

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_TablistGrid = _resolveComponent("TablistGrid")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_NeuePagination = _resolveComponent("NeuePagination")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Workflows" }, {
        right: _withCtx(() => [
          _createVNode(NewAutomationButton, { type: "workflow" })
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NeueWell, { class: "mb-8" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Workflows react to things your customers do. When the trigger fires, every action in the workflow runs for that customer automatically. ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            (workflows.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_NeueTablist, null, {
                      head: _withCtx(() => [
                        _createVNode(_component_TablistHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_TablistGrid, {
                              columns: columns,
                              header: ""
                            }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("div", null, "Name", -1),
                                _createElementVNode("div", null, "Trigger", -1),
                                _createElementVNode("div", null, "Actions", -1),
                                _createElementVNode("div", null, "Created", -1),
                                _createElementVNode("div", null, "Status", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageRows.value, (workflow) => {
                          return (_openBlock(), _createBlock(_component_TablistRow, {
                            key: workflow.id,
                            class: "cursor-pointer",
                            onClick: $event => (_ctx.$router.push('/automation/workflow/' + workflow.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_TablistGrid, { columns: columns }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, _toDisplayString(workflow.attributes.name), 1),
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(triggerLabel(workflow)), 1),
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(actionsLabel(workflow)), 1),
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(createdAt(workflow.attributes.created_at)), 1),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass([
                          statusBadge(workflow).classes,
                          'px-2 inline-flex text-xs leading-5 font-semibold rounded-full'
                        ])
                                    }, _toDisplayString(statusBadge(workflow).label), 3)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_NeuePagination, {
                    size: workflows.value.length,
                    from: page.value * pageSize + 1,
                    to: Math.min((page.value + 1) * pageSize, workflows.value.length),
                    onPrev: _cache[0] || (_cache[0] = 
                ret => {
                  page.value--
                  ret()
                }
              ),
                    onNext: _cache[1] || (_cache[1] = 
                ret => {
                  page.value++
                  ret()
                }
              )
                  }, null, 8, ["size", "from", "to"])
                ]))
              : (_openBlock(), _createBlock(_component_NeueWell, {
                  key: 1,
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EmptyState, { plural: "workflows" })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}